import { Component, OnInit } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { BaseComponent } from 'src/shared/abstracts/base.abstract';
import { ModalService } from 'src/shared/services';

import { AuthState } from '../shared/store/state/auth.state';
import { MenuState } from '../shared/store/state/menu.state';
import { defaultLanguage } from './app-routing.module';

const APP_LOCALES = ['fr', 'nl'];
const LANG_COOKIE_NAME = 'defaultLangWASO';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent extends BaseComponent implements OnInit {
    @Select(MenuState.isOpen) public isMenuOpen$: Observable<boolean>;
    @Select(AuthState.isLoading) public isLoading$: Observable<boolean>;

    public title = 'MAIN.TITLE';

    private url: string;

    constructor(private router: Router, private modalService: ModalService) {
        super();
    }

    ngOnInit(): void {
        this.redirectLegacyAuthUrls();

        this.uns = this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                if (this.url !== event.url) {
                    this.modalService.closeModal();
                }
                this.url = event.url;
            }
        });
    }

    public get hasSubMenu(): boolean {
        return this.url?.includes('/shopping') || this.url?.includes('/messaging');
    }

    public get isLoginWrapper(): boolean {
        return this.url?.includes('/terms-of-service') || this.url?.includes('/auth');
    }

    /** Auth emails used to omit /fr|nl/; ngx-translate-router requires a locale prefix. */
    private redirectLegacyAuthUrls(): void {
        const [path, query] = this.router.url.split('?');
        const segments = path.split('/').filter(Boolean);

        if (!segments.length || APP_LOCALES.includes(segments[0]) || segments[0] !== 'auth') {
            return;
        }

        const lang = defaultLanguage(APP_LOCALES, this.getCachedLang());
        const newUrl = `/${lang}${path}${query ? `?${query}` : ''}`;
        this.router.navigateByUrl(newUrl, { replaceUrl: true });
    }

    private getCachedLang(): string | undefined {
        const match = document.cookie.match(new RegExp(`${LANG_COOKIE_NAME}=([^;]+)`));
        return match?.[1];
    }
}
